import { render, staticRenderFns } from "./BebambiCaseStudy.vue?vue&type=template&id=7ad8757c&scoped=true"
import script from "./BebambiCaseStudy.vue?vue&type=script&lang=js"
export * from "./BebambiCaseStudy.vue?vue&type=script&lang=js"
import style0 from "./BebambiCaseStudy.vue?vue&type=style&index=0&id=7ad8757c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad8757c",
  null
  
)

export default component.exports